import { jsx as a } from "react/jsx-runtime";
import { PaddingSize as i, HeadingLevel as r } from "../../enums.js";
import { composeIDSCard as h } from "./helpers/composeIDSCard.js";
import { composeIDSCardSlots as k } from "./helpers/composeIDSCardSlots.js";
import { HeadingWithDeprecatedFallback as D } from "../HeadingWithDeprecatedFallback/HeadingWithDeprecatedFallback.js";
const t = ({
  className: n,
  padding: c = i.Md,
  selected: m,
  stretch: s,
  children: l,
  footer: p,
  heading: d,
  headingLevel: g = r.H2,
  headingText: e,
  media: f,
  prepend: C,
  topRight: H,
  ...o
}) => {
  const v = d || e ? /* @__PURE__ */ a(
    D,
    {
      component: "IressCard",
      heading: d,
      headingText: e,
      HeadingTag: g
    }
  ) : void 0, I = h({
    className: n,
    clickable: !!o.onClick,
    padding: c,
    selected: m,
    stretch: s
  }), S = k({
    children: l,
    "data-testid": o["data-testid"],
    footer: p,
    heading: v,
    media: f,
    prepend: C,
    topRight: H
  });
  return /* @__PURE__ */ a("div", { ...o, ...I, children: S });
};
t.HeadingLevel = r;
t.Padding = i;
export {
  t as IressCard
};
